import { Component, OnInit } from '@angular/core';
import {
  Validators,
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { PublicExposedPersonDialogComponent } from '../dialogs/public-exposed-person-dialog/public-exposed-person-dialog.component';
import {
  BUTTON_SUBMIT_TEXT,
  NEGATIVE_TEXT,
  AFFIRMATIVE_TEXT,
  QUESTION_DIALOG_TEXT
} from '../../shared/resources/texts.constant';
import { Router } from '@angular/router';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { AnalyticService } from 'src/app/shared/services/analytic.service';
import { FiscalOfficerComponent } from '../dialogs/fiscal-officer/fiscal-officer.component';

@Component({
  selector: 'app-publicy-exposed-person',
  templateUrl: './publicy-exposed-person.component.html',
  styleUrls: ['./publicy-exposed-person.component.scss']
})
export class PublicyExposedPersonComponent implements OnInit {
  public pepForm: UntypedFormGroup = {} as UntypedFormGroup;
  readonly BUTTON_SUBMIT_TEXT = BUTTON_SUBMIT_TEXT;
  readonly NEGATIVE_TEXT = NEGATIVE_TEXT;
  readonly AFFIRMATIVE_TEXT = AFFIRMATIVE_TEXT;
  readonly QUESTION_DIALOG_TEXT = QUESTION_DIALOG_TEXT;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public breakpointObserver: BreakpointObserver,
    public analytic: AnalyticService
  ) {}

  ngOnInit() {
    this.pepForm = this.fb.group({
      firstPepInput: ['', Validators.required],
      secondPepInput: ['', Validators.required]
    });
  }

  openPepDialog(): void {
    this.dialog.open(PublicExposedPersonDialogComponent, {
      data: '',
      disableClose: true,
      panelClass: 'dialog-overlay',
      maxWidth: this.breakpointObserver.isMatched('(max-width: 480px)')
        ? '100vw'
        : '480px'
    });
  }

  openFiscalDialog(): void {
    this.dialog.open(FiscalOfficerComponent, {
      data: '',
      disableClose: true,
      panelClass: 'dialog-overlay',
      maxWidth: this.breakpointObserver.isMatched('(max-width: 480px)')
        ? '100vw'
        : '480px'
    });
  }

  onSubmit(): void {
    const firstPep = JSON.parse(
      (this.pepForm.get('firstPepInput')!.value as string).toLowerCase()
    );
    const secondPep = JSON.parse(
      (this.pepForm.get('secondPepInput')!.value as string).toLowerCase()
    );

    if (firstPep || secondPep) {
      this.analytic.uTagLinkError('Error usuario PEP', 'error_user_page');
      this.router.navigate([routesData.ERRORS.USER_ERROR.redirectPath]);
    } else {
      this.router.navigate([routesData.CDT_CONFIGURATION.redirectPath]);
    }
  }
}
